import { defineMessages } from 'react-intl';

/** The copy of design whats-new a1-a5. */
export const whatsNewMessages = defineMessages({
  kickerAfter: { id: 'app.sml.whatsNew.kicker.after', defaultMessage: 'What’s new' },
  kickerAvailable: { id: 'app.sml.whatsNew.kicker.available', defaultMessage: 'Update ready' },
  subtitleAfter: {
    id: 'app.sml.whatsNew.subtitle.after',
    defaultMessage: '{count, plural, one {# change in this version.} other {# changes in this version.}}',
  },
  subtitleAvailable: {
    id: 'app.sml.whatsNew.subtitle.available',
    defaultMessage: 'You use {current}. Reload when you are ready. Nothing reloads by itself.',
  },
  more: { id: 'app.sml.whatsNew.more', defaultMessage: 'Also in this version' },
  categoryFeature: { id: 'app.sml.whatsNew.category.feature', defaultMessage: 'New' },
  categoryImprovement: { id: 'app.sml.whatsNew.category.improvement', defaultMessage: 'Better' },
  categoryFix: { id: 'app.sml.whatsNew.category.fix', defaultMessage: 'Fixed' },
  before: { id: 'app.sml.whatsNew.story.before', defaultMessage: 'Before' },
  now: { id: 'app.sml.whatsNew.story.now', defaultMessage: 'Now' },
  seeAll: { id: 'app.sml.whatsNew.seeAll', defaultMessage: 'See all changes' },
  gotIt: { id: 'app.sml.whatsNew.gotIt', defaultMessage: 'Got it' },
  later: { id: 'app.sml.whatsNew.later', defaultMessage: 'Later' },
  reload: { id: 'app.sml.whatsNew.reload', defaultMessage: 'Reload' },
  close: { id: 'app.sml.whatsNew.close', defaultMessage: 'Close' },
});
